import request from '@/request/request'

// 查询区域列表
export function listEquipmentArea(query) {
    return request({
        url: '/equipment-server/equipmentArea/list',
        method: 'get',
        params: query
    })
}

// 查询区域详细
export function getEquipmentAreaById(id) {
    return request({
        url: '/equipment-server/equipmentArea/' + id,
        method: 'get'
    })
}

// 新增区域
export function addEquipmentArea(data) {
    return request({
        url: '/equipment-server/equipmentArea',
        method: 'post',
        data: data
    })
}

// 修改区域
export function updateEquipmentArea(data) {
    return request({
        url: '/equipment-server/equipmentArea/edit',
        method: 'post',
        data: data
    })
}

// 删除区域
export function delEquipmentArea(id) {
    return request({
        url: '/equipment-server/equipmentArea/delete/' + id,
        method: 'post'
    })
}


// 查询区域树-除了客流密度
export function listEquipmentAreaTree(query) {
    return request({
        url: '/equipment-server/equipmentArea/tree',
        method: 'get',
        params: query
    })
}
// 查询区域树-客流密度
export function listEquipmentAreaTreePassengerFlow(query) {
    return request({
        url: '/equipment-server/warnConfig/hikGroupAll',
        method: 'post',
        params: query
    })
}